import * as React from "react";
import { ChevronUp, ChevronDown } from "lucide-react";
import { Button } from "@/components/ui/button";
import {
  Collapsible,
  CollapsibleContent,
  CollapsibleTrigger,
} from "@/components/ui/collapsible";
import clsx from "clsx";

interface CustomCollapsibleProps {
  title: string;
  children: React.ReactNode;
  isOpenDefault?: boolean;
  className?: string;
  hideToggle?: boolean;
  openOverride?: boolean;
}

export default function CustomCollapsible({
  title,
  children,
  isOpenDefault = true,
  className,
  hideToggle = true,
  openOverride,
}: CustomCollapsibleProps) {
  const [isOpen, setIsOpen] = React.useState<boolean>(isOpenDefault);

  const toggleCollapsible = () => {
    setIsOpen(!isOpen);
  };

  React.useEffect(() => {
    if (openOverride !== undefined) {
      setIsOpen(openOverride);
    }
  }, [openOverride]);

  return (
    <Collapsible
      open={isOpen}
      onOpenChange={toggleCollapsible}
      className={clsx("w-full", className)} // Merge custom className with default styles
    >
      <div className="shadow-sm rounded-2xl p-3 w-full">
        <div className="cursor-pointer">
          <div
            onClick={toggleCollapsible}
            className={`flex items-center justify-between ${isOpen ? "border-b" : ""}`}
          >
            <h3 className="text-lg font-medium  ">{title}</h3>
            {!hideToggle && (
              <CollapsibleTrigger>
                <Button variant="ghost" size="sm" className="w-9 p-0">
                  {isOpen ? (
                    <ChevronUp className="size-4 text-black" />
                  ) : (
                    <ChevronDown className="size-4 text-black" />
                  )}
                  <span className="sr-only">Toggle</span>
                </Button>
              </CollapsibleTrigger>
            )}
          </div>
        </div>
        <CollapsibleContent>
          <div className="mt-2">{children}</div>
        </CollapsibleContent>
      </div>
    </Collapsible>
  );
}
